module.exports = __webpack_public_path__ + "img/ic_24_whitelabel_server.13649fe5.svg";